import { checkoutOptimizationStepArraySchema } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import * as z from "zod";

export const createProspectiveCheckoutSplitFromFlowSteps = {
  name: "createProspectiveCheckoutSplitFromFlowSteps" as const,
  input: z.object({ flowSteps: checkoutOptimizationStepArraySchema }),
  output: z.null(),
};
